import { getFileExtension } from "../../../helpers/utils/utils";

const COVER_IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "webp"];

export const normalizeAllegati = (allegati = []) => {
  if (!Array.isArray(allegati)) return [];

  return allegati.map((item) => {
    if (typeof item === "string") {
      return { id: item, name: "" };
    }

    const nameWithoutId = item?.name?.includes(item.id)
      ? item.name.replace(`${item.id}\\`, "")
      : item.name;

    return {
      id: item.id,
      name: nameWithoutId,
      isCover: item.isCover,
    };
  });
};

export const isImageFileName = (fileName) => {
  const ext = getFileExtension(fileName || "")?.toLowerCase();
  return COVER_IMAGE_EXTENSIONS.includes(ext);
};

export const isCoverAttachment = (file) => file?.isCover === true;

export const getCoverFromAllegati = (allegati = []) => {
  if (!Array.isArray(allegati)) return null;

  return (
    allegati.find(isCoverAttachment) ||
    allegati.find((file) => isImageFileName(file?.name))
  );
};

export const getPdfAllegati = (allegati = []) => {
  if (!Array.isArray(allegati)) return [];

  const cover = getCoverFromAllegati(allegati);

  return allegati.filter(
    (file) =>
      file !== cover &&
      !isCoverAttachment(file) &&
      getFileExtension(file?.name || "")?.toLowerCase() === "pdf"
  );
};

export const upsertCoverInAllegati = (allegati = [], coverFile) => {
  const cover = getCoverFromAllegati(allegati);
  const withoutCover = allegati.filter(
    (file) => file !== cover && !isCoverAttachment(file)
  );

  return [...withoutCover, { ...coverFile, isCover: true }];
};

export const removeCoverFromAllegati = (allegati = []) => {
  const cover = getCoverFromAllegati(allegati);

  return allegati.filter(
    (file) => file !== cover && !isCoverAttachment(file)
  );
};
